import React, { useEffect, useRef, useState } from 'react'
import { CTable, CTableHead, CTableRow, CTableHeaderCell, CTableBody, CTableDataCell } from '@coreui/react'
const LabDisplayComponent = ({ allLabs, diagnosis, showDataIfNoteIsFollowUp = false, diagnosisAddedPinger, noteStructureRef, showComment, showTreatmentAsAccordion }) => {
  const [matchingLab, setMatchingLab] = useState([])

  useEffect(() => {
    const lastLab = allLabs[0] || []
    const lastLabArrOfLabs = lastLab?.data || []
    const allMatchingLab =
      lastLabArrOfLabs &&
      lastLabArrOfLabs.filter((item) => {
        const diagnosisLab = item.diagnosis.split(',').filter((item) => item !== '')
        return diagnosisLab.some((diagn) => diagn.includes(diagnosis))
      })
    setMatchingLab(allMatchingLab)
    if (noteStructureRef) {
      noteStructureRef.current = {
        ...noteStructureRef.current,
        labDetails: {
          ...noteStructureRef.current.labDetails,
          [diagnosis]: allMatchingLab ? allMatchingLab : [],
        },
      }
    }
  }, [allLabs, diagnosisAddedPinger])

  //     useEffect(() => {
  //         const lastLab = allLabs[allLabs.length - 1];
  //         const lastLabArrOfLabs = lastLab?.data  || [];
  //         if(diagnosis === 'Cognitive Communication Deficit'){
  //         }
  //         const filteredLabs = lastLabArrOfLabs
  //     .map(lab => {
  //       const matchingData = lab?.data?.filter(item => {
  //         const diagnosisList = item.diagnosis?.split(',').map(d => d.trim()) || [];
  //         return diagnosisList.includes(diagnosis);
  //       });

  //       if (matchingData.length) {
  //         return {
  //           ...lab,
  //           data: matchingData, // Keep only matched lab data
  //         };
  //       }

  //       return null;
  //     })
  //     .filter(Boolean); // Remove nulls

  //   setMatchingLab(filteredLabs);

  //         const allMatchingLab = lastLabArrOfLabs && lastLabArrOfLabs.filter((item) => {
  //             const diagnosisLab = item.diagnosis.split(",").filter(item => item !== '');
  //             return diagnosisLab.some(diagn => diagn.includes(diagnosis));
  //         });
  //         // setMatchingLab(allMatchingLab);
  //         if (noteStructureRef) {
  //             noteStructureRef.current = {
  //                 ...noteStructureRef.current,
  //                 labDetails: {
  //                     ...noteStructureRef.current.labDetails,
  //                     [diagnosis]: allMatchingLab ? allMatchingLab : []
  //                 }
  //             };
  //         }
  //     }, [allLabs, diagnosisAddedPinger]);

  return (
    <>
      {matchingLab.length > 0 ? (
        <>
          {/* <b>Date: {allLabs[allLabs.length - 1]?.date}</b> */}
          {/* <CTable>
                <CTableHead>
                    <CTableRow>
                        <CTableHeaderCell>Lab Name</CTableHeaderCell>
                        <CTableHeaderCell>Value</CTableHeaderCell>
                        <CTableHeaderCell>Unit</CTableHeaderCell>
                        <CTableHeaderCell>Range</CTableHeaderCell>
                        <CTableHeaderCell>Diagnosis</CTableHeaderCell>
                        <CTableHeaderCell>Remark</CTableHeaderCell>
                    </CTableRow>
                </CTableHead>
                <CTableBody>
                    {matchingLab.map((lab, labIndex) => (
                        <CTableRow key={labIndex}>
                            <CTableDataCell>{lab.name}</CTableDataCell>
                            <CTableDataCell>{lab.value || '-'}</CTableDataCell>
                            <CTableDataCell>{lab.unit}</CTableDataCell>
                            <CTableDataCell>{lab.range}</CTableDataCell>
                            <CTableDataCell>{lab.diagnosis}</CTableDataCell>
                            <CTableDataCell>{lab.remark}</CTableDataCell>
                        </CTableRow>
                    ))}
                </CTableBody>
            </CTable> */}
          <div>
            <div className=" text-warning gap-1">
              <p>{new Date(allLabs[0]?.date || new Date()).toLocaleDateString('en-US')}</p>
            </div>
            {matchingLab
              .sort((a, b) => new Date(b?.date) - new Date(a?.date))
              .map((lab, idx) => {
                return (
                  <div key={idx} className="d-flex flex-column text-warning gap-1">
                    {/* <p>{new Date(allLabs[allLabs.length - 1]?.date).toLocaleDateString('en-US')}</p> */}
                    {/* {item?.data?.map((lab, index) => {
                                                return (
                                                    <div key={index} className='d-flex text-warning gap-1'>
                                                        <p>{lab.name}</p>
                                        <p className=''>{lab.value}</p>
                                        <p className='text-nowrap'>{lab.unit}</p>
                                        <p>{item.range}</p>
                                        <p>{item.diagnosis}</p>
                                        {showComment && <p>{lab?.comment}</p>}
                                                    </div>
                                                )
                                            })
                                        } */}
                    <div className="d-flex text-warning gap-1">
                      <p>{lab.name}</p>
                      <p className="">{lab.value}</p>
                      <p className="text-nowrap">{lab.unit}</p>
                      {/* <p>{item.range}</p>
                                        <p>{item.diagnosis}</p> */}
                      {showComment && <p>{lab?.comment}</p>}
                    </div>
                  </div>
                )
              })}
          </div>
        </>
      ) : (
        <p> </p>
      )}
    </>
  )
}

export default LabDisplayComponent
